<div style="z-index: 1100" class="fixed pointer-events-none" [class]="getPositionClasses()">
  <div class="flex flex-col gap-2 pointer-events-auto">
    @for (toast of toasts(); track toast.id) {
      <app-toast [config]="toast" (close)="removeToast(toast.id)" />
    }
  </div>
</div>
